export function getPercentageValue(value: number | string) {
  return value ? `${value}%` : value;
}
